import { render } from "./PossessionPills.vue?vue&type=template&id=66e9b3aa"
import script from "./PossessionPills.vue?vue&type=script&lang=js"
export * from "./PossessionPills.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\phili\\work\\dingsda\\dingsda_2mex_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__